
import { createClient,defaultExchanges } from "urql";
import Configuration from "../configs/Config";


export const client = createClient({
  url: Configuration.urlGraphQl,
  exchanges: [...defaultExchanges],
  // KHU VỰC THAY ĐỔI: Đọc cấu hình runtime khi gửi request GraphQL.
  fetchOptions: () => ({
    headers: {
      "x-api-key": window.config?.xApiKey || "",
    },
  }),
  // KẾT THÚC THAY ĐỔI

});
